import { defineModule } from '../types';
import { legacyPublicRoutes, legacyRoutes } from './routes';

/**
 * MOVIT's old addresses (bookmarks, links in old e-mails) redirected to their Nova places. No
 * server module, no navigation, no pages of its own — see `routes.ts` for the map.
 */
export const legacyModule = defineModule({
  key: 'legacy',
  routes: legacyRoutes,
  publicRoutes: legacyPublicRoutes,
  nav: [],
});
